import React, { useRef, useState } from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Menu } from 'lucide-react'
import bg from "../assets/bg.webp"
import Loader from '../components/Loader';
import balcony from "../assets/balcony.png"
import door from "../assets/door.png"
import panjur from "../assets/panjur.png"
import sineklik from "../assets/sineklik.png"
import window from "../assets/window.png"
import bath from "../assets/dus.png"
import p1 from "../assets/balkon.webp"
import p2 from "../assets/2.webp";
import p3 from "../assets/3.webp";
import p4 from "../assets/4.webp";
import p5 from "../assets/pvc.webp";
import p6 from "../assets/6.webp";
import logo from "../assets/acarpenlogo3.png";

import Button from '../components/Button';
import Contact from '../components/Contact';
import Carousel from '../components/Carousel';
import Card from '../components/Section';
import Footer from '../components/Footer'
import { useNavigate } from 'react-router-dom'
import "../index.css"
import { Helmet } from 'react-helmet'
const backgroundImages = [p1, p2, p3, p6, p5, p4];

const ServicesContainer = styled.div` 
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  margin-bottom: 200px;
  color: #111111;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    margin-bottom: 100px;
  }
`;

const ServiceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding: 30px;
  border: 1px solid #0000008f;
  transition: transform 0.3s ease;
  background: #0000003a;
  height: 239px;
  position: relative;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: ${({ index }) => `url(${backgroundImages[index]})`};
    background-size: cover;
    background-position: center;
    opacity: 0;
    transform: scale(1.1);
    transition: transform 0.6s ease, opacity 0.6s ease;
    z-index: -1;
  }

  &:hover:before {
    opacity: 1;
    transform: scale(1);
  }

  &:hover {
    transform: scale(1);
  }

  &:nth-child(3n+1) { border-right: none; }
  &:nth-child(3n) { border-left: none; }
  &:nth-child(-n+3) { border-bottom: none; }

  @media (max-width: 768px) {
    height: 200px;
    &:nth-child(n) {
      border: 1px solid #0000008f;

    }
  }
`;

const Icon = styled.div`
  color: #e60000;
  font-size: 36px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  border-radius: 50%;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 10px;
  }
`;

const Title = styled.h3`
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 300;
  color: #ffffff;
  font-family: Poppins;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;



const Arrow = styled.div`
  color: #111111;
  font-size: 24px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const FullScreenContainer = styled(Container)`
  position: relative;
  height: 170vh;
  width: 100vw;
  overflow-x: hidden;
  margin-bottom: -478px;
  background-image: url(${bg});
  background-size: cover;
  background-position: bottom;

  @media (max-width: 768px) {
    height: 310vh;
    margin-bottom: -1200px;
  }
`;

const NavigationBar = styled(Container)`
  width: 100vw;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 0 20px;
  }
`;

const MenuItems = styled.div`
  display: flex;
  text-decoration: none;
  gap: 80px;
  margin: 25px;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100px;
    right: 0;
    background: white;
    width: 200px;
    gap: 20px;
    padding: 20px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    z-index: 1000;
    margin: 0;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 20px;
  color: white;
  @media (max-width: 768px) {
    display: block;
  }
`;

const TitleForm = styled.h1`
  margin-bottom: 25px;
  font-size: 40px;
  
  text-align: center;
  font-family: Poppins;
  font-weight: 700;
  color: #212d31;

  @media (max-width: 768px) {
    font-size: 28px;
    padding: 0 20px;
  }
`;

const StyledTitle = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  color: #ffffff;
  font-weight: 500;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 15px;
    margin: 0;
    color: #282828dd;
    padding: 10px;
  }
`;

const Exp = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  color: #7d7c7b;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 0 20px;
    text-align: center;
  }
`;
const Statistic = styled.h3`
  font-size: 65px;
  margin: 30px;
  font-weight: 500;
  color: #D40D12;
  font-family: Poppins;

  @media (max-width: 768px) {
    font-size: 45px;
    margin: 15px;
  }
`;

const Text = styled.h3`
  font-size: 20px;
  font-weight: 500;
  color: #292929;
  font-family: Poppins;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 70px;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 20px;
  }
`;

const LeftSection = styled.div`
  width: 60%;
  text-align: left;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

const RightSection = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 30px;
  }
`;

const StatisticBox = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  width: 70%;
  justify-content: flex-start;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 90%;
  }
`;



const Logo = styled.img`
  width: 200px;
  cursor:pointer;
  
  @media (max-width: 768px) {
    width: 130px;
  }
`;

const ResponsiveContainer = styled.div`
  width: 100vw;
  height: 60vh;
  display: flex;
  align-items: center;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: -50px;
  }
`;

const InnerContent = styled.div`
  width: 60vw;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 100vw;
    margin-left: 0;
  }
`;

const LoaderContainer = styled.div`
  height: 230px;
  display: flex;
  align-items: center;
  margin-top: 50px;
  justify-content: flex-start;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const TextContainer = styled.div`
  margin-left: 100px;
  width: 65%;
  text-align: left;
  padding: 0;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 85%;
    text-align: center;
    margin-top: -30px;
  }
`;

const StyledParagraph = styled.p`
  font-family: 'Poppins';
  font-size: 18px;
  color: #ffffff;
  font-weight: 300;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledWrapper = styled.div`
  margin-top: 30px;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  button {
    position: relative;
    display: inline-block;
    cursor: pointer;
    outline: none;
    border: 0;
    vertical-align: middle;
    text-decoration: none;
    background: transparent;
    padding: 0;
    font-family: Poppins;
  }

  button.learn-more {
    width: 12rem;
    height: auto;
  }

  button.learn-more .circle {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: relative;
    display: block;
    margin: 0;
    width: 3rem;
    height: 3rem;
    background: #D40D12;
    border-radius: 1.625rem;
  }

  button.learn-more .circle .icon {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #fff;
  }

  button.learn-more .circle .icon.arrow {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    left: 0.625rem;
    width: 1.125rem;
    height: 0.125rem;
    background: none;
  }

  button.learn-more .circle .icon.arrow::before {
    position: absolute;
    content: "";
    top: -0.29rem;
    right: 0.0625rem;
    width: 0.625rem;
    height: 0.625rem;
    border-top: 0.125rem solid #fff;
    border-right: 0.125rem solid #fff;
    transform: rotate(45deg);
  }

  button.learn-more .button-text {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.75rem 0;
    font-size: 18px;
    margin: -1px 0 0 35px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }

  button:hover .circle {
    width: 100%;
  }

  button:hover .circle .icon.arrow {
    background: #fff;
    transform: translate(1rem, 0);
  }

  button:hover .button-text {
    color: #fff;
  }

  @media (max-width: 768px) {
    button.learn-more {
      width: 10rem;
      margin-top:50px ;
    }

    button.learn-more .button-text {
      font-size: 16px;
    }
  }
`;
const Dashboard = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
   const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };




  return (
    <div className='w-full' style={{ overflowX: "hidden" }}>
            <Helmet>
        <title>Acar Pen - Ev Sistemlerinde En Kaliteli Ürünler</title>
        <meta name="description" content="Pvc Pencere Kapı,Cam Balkon,Panjur,Duşakabin,Sineklik Sistemleri ile Evinize Şıklık Katın." />
        <meta name="keywords" content="söke cam balkon,kuşadası cam balkon, didim cam balkon,cam balkon fiyatları,söke pencere,söke cam balkon,fiyatları,söke pencere,didim" />
      </Helmet>
      <FullScreenContainer fluid>
        <NavigationBar>
          <div onClick={()=> navigate("/")}>
            <Logo src={logo} alt="logo" />
          </div>
          <MenuButton onClick={toggleMenu}>
            <Menu size={24} />
          </MenuButton>
          <MenuItems isOpen={isMenuOpen}>
          <a href="#hizmetler">   <StyledTitle>HİZMETLERİMİZ</StyledTitle></a>
            <StyledTitle>HAKKIMIZDA</StyledTitle>
            <a href="##">  <StyledTitle>İLETİŞİM</StyledTitle></a>
          </MenuItems>
        </NavigationBar>

        <ResponsiveContainer>
    <InnerContent>
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
      <TextContainer>
        <StyledParagraph>
          Kalite ve estetiği uygun fiyatlarla bir araya getirerek, profesyonel işçilikle ürettiğimiz cam balkon,
          duşakabin, pencere ve panjur sistemleriyle evinizi yeniliyoruz.
        </StyledParagraph>

        {/* Copyright - 2024 cssbuttons-io (cssbuttons.io) 

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */}


        <StyledWrapper>
          <button className="learn-more">
            <span className="circle" aria-hidden="true">
              <span className="icon arrow" />
            </span>
            <a href="##">
              <span className="button-text">Teklif Alın</span>
            </a>
          </button>
        </StyledWrapper>
      </TextContainer>
    </InnerContent>
  </ResponsiveContainer>

      </FullScreenContainer>

      <ServicesContainer>
        {[
    { title: 'Cam Balkon', icon: balcony, path: '/cam-balkon-sistemleri' },
    { title: 'Duşakabin', icon: bath, path: '/dusakabin-sistemleri' },
    { title: 'Otomatik Panjur', icon: panjur, path: '/panjur-sistemleri' },
    { title: 'PVC Kapı', icon: door, path: '/kapi-pencere-sistemleri' },
    { title: 'PVC Pencere', icon: window, path: '/kapi-pencere-sistemleri' },
    { title: 'Sineklik', icon: sineklik, path: '/sineklik-sistemleri' },
        ].map((service, index) => (
          <ServiceBox
            key={index}
            id="hizmetler"
            index={index}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => navigate(service.path)}
          >
            <Icon>
              <img src={service.icon} alt={service.title} style={{ width: '40px', height: '40px' }} />
            </Icon>
            <Title>{service.title}</Title>
            <Button className={hoveredIndex === index ? 'hovered' : ''} />
            
          </ServiceBox>
        ))}
      </ServicesContainer>

    <Wrapper>
      <LeftSection>
        <p style={{ fontFamily: "Poppins", fontWeight: "600", fontSize: "40px", color: "#353535", marginBottom: "30px" }}>
          Her Detayda Uzmanlık, <br /> Her Projede Memnuniyet
        </p>
        <Exp>
          Yüksek kaliteli ürünlerimiz ve müşteri odaklı hizmet anlayışımızla, sektörde güvenilir bir konumdayız.
          Kurulduğumuz günden bu yana dayanıklılığı ve estetiği bir araya getiren ürünler sunarak, müşterilerimizin yaşam alanlarına değer katıyoruz. 
          Her müşterimizin ihtiyacına özel çözümlerle, memnuniyeti sağlamak ve beklentileri en iyi şekilde karşılamak için buradayız. 
          Bugüne dek 1000'den fazla müşterimizin güvenini kazanmış olmanın gururunu taşıyor, her geçen gün yeni projelerle büyümeye devam ediyoruz.
        </Exp>
      </LeftSection>
      <RightSection>
        <StatisticBox>
          <Statistic>+7</Statistic>
          <Text>yıllık deneyim</Text>
        </StatisticBox>
        <StatisticBox>
          <Statistic>+1000</Statistic>
          <Text>mutlu müşteri</Text>
        </StatisticBox>
        <StatisticBox>
          <Statistic>+1500</Statistic>
          <Text>tamamlanan proje</Text>
        </StatisticBox>
      </RightSection>
    </Wrapper>
    
      <Carousel/>
      <Card/>
      <TitleForm id="#" >Hayalinizdeki Mekanı Birlikte Tasarlayalım</TitleForm>
      <p style={{
        fontFamily: "Poppins",
        color: "#757575",
        textAlign: "center",
        fontSize: window.innerWidth <= 768 ? '16px' : '18px',
        padding: window.innerWidth <= 768 ? '0 20px' : '0'
      }}>
        Ücretsiz keşif ve teklif için hemen iletişime geçin!
      </p>
      <Contact/>
      <Footer/>
    </div>
  );
};

export default Dashboard;